import { createContext } from "react";

import { LastLocation } from "./types";

const LastLocationContext = createContext<LastLocation>(null);

export default LastLocationContext;
